import { attributes, html } from 'BomdisoftComponents/html/index';

export type CodeInputOptions = {
  disabled?: boolean;
  label: string;
  length?: number;
  testId?: string;
  value: string;
};

export type CodeEntry = {
  focusIndex: number | null;
  value: string;
};

export const typeIntoCode = (value: string, index: number, typed: string, length: number): CodeEntry => {
  const digits = typed.replace(/\D/g, '');
  const chars = value.padEnd(length, ' ').split('');
  if (digits === '') {
    chars[index] = ' ';
    return { focusIndex: null, value: chars.join('').trimEnd() };
  }
  for (let offset = 0; offset < digits.length && index + offset < length; offset += 1) {
    chars[index + offset] = digits[offset];
  }
  return { focusIndex: Math.min(index + digits.length, length - 1), value: chars.join('').trimEnd() };
};

export const toCellValue = (value: string, index: number) => (value[index] ?? '').trim();

export const renderCodeInput = ({ disabled, label, length = 6, testId, value }: CodeInputOptions) =>
  html`<div${attributes({ class: 'bomdisoft-code-input-cells', 'data-testid': testId })}>${Array.from(
    { length },
    (_, index) => html`<input${attributes({ 'aria-label': `${label} ${index + 1}`, autocomplete: index === 0 ? 'one-time-code' : 'off', class: 'bomdisoft-code-input-cell', disabled, inputmode: 'numeric', maxlength: length, type: 'text', value: toCellValue(value, index) })}>`,
  )}</div>`;
